import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup } from '@angular/forms';
import { SelectService } from './select.service';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  field: FieldConfig;
  group: FormGroup;
  valueSelected: any;

  constructor(private selectService: SelectService) { }

  ngOnInit(): void {

  }

  click(name, value, optName): void {
    if(this.valueSelected!== value){
      this.valueSelected=value;
      this.selectService.onSelectionChange({name, value , optName});
    } else{
      console.log('no cambio')
    }
  }

}
